<template>
  <b-card class="blue-linear-gradient">
    <b-row>
      <b-col cols="12" md="auto" class="text-center">
        <b-avatar variant="primary" size="2.875rem" class="m-3 m-md-0">
          <kudos-icon style="font-size:2rem" />
        </b-avatar>
      </b-col>
      <b-col>
        <h5 class="font-weight-bold text-center text-md-left">Send your first kudo</h5>
        <div class="font-size-xs">Take time to value one of your peer by sending a kudo</div>
      </b-col>
      <b-col cols="12" md="auto" class="align-self-center text-center m-3 m-md-0">
        <b-link @click="modalShow = !modalShow">See how</b-link>
        <b-modal v-model="modalShow" hide-header hide-footer size="lg" content-class="bg-color-darkgray">
          <kudo-instructions />
        </b-modal>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import KudosIcon from '@/assets/images/kudos.svg'
import KudoInstructions from '@/components/KudoInstructions'

export default {
  name: 'SendFirstKudo',

  data() {
    return {
      modalShow: false
    }
  },

  components: {
    KudosIcon,
    KudoInstructions
  }
}
</script>
